import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'pcm-data-modal-export',
	templateUrl: './data-modal-export.component.html',
	styleUrls: ['../data-modal/data-modal.component.scss', './data-modal-export.component.scss']
})
export class DataModalExportComponent implements OnInit {
	@Input() title = '';
	@Input() fileType = 'csv';
	@Output() formSubmit: EventEmitter<any> = new EventEmitter();
	@Output() formCancel: EventEmitter<any> = new EventEmitter();
	filename = '';
	helpText = 'This will be downloaded as a CSV file. Use Microsoft Excel to open the exported csv file for the correct format.';

	constructor() { }

	ngOnInit() {
		if (this.fileType !== 'csv') {
			this.helpText = 'Please use .' + this.fileType + ' for the extension of the filename.';
		}
	}

	pageFormSubmit(event) {
		console.log('Export MODAL FORM SUBMIT', event);
		event.data = this.filename;
		this.formSubmit.emit(event);
	}

	pageFormCancel(event) {
		this.formCancel.emit(event);
	}
}
